import { Column, Entity, Index, PrimaryGeneratedColumn } from "typeorm";

@Index("class", ["class"], {})
@Index("subject", ["subject"], {})
@Index("chapter", ["chapter"], {})
@Index("estatus", ["estatus"], {})
@Index("timestamp", ["timestamp"], {})
@Entity("topic")
export class Topic {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("int", { name: "class", default: () => "'0'" })
  class: number;

  @Column("int", { name: "subject", default: () => "'0'" })
  subject: number;

  @Column("int", { name: "chapter", default: () => "'0'" })
  chapter: number;

  @Column("text", { name: "topic" })
  topic: string;

  @Column("tinyint", { name: "estatus", default: () => "'1'" })
  estatus: number;

  @Column("varchar", { name: "timestamp", length: 20, default: () => "''" })
  timestamp: string;
}
